module.exports = __webpack_public_path__ + "static/assets/a9a3a6a0de1af7f2523608c82d98c0ab.svg";